<template>
  <modal name="create-milestone-modal" width="90%" height="90%">
    <Button
      class="close"
      @click.native="closeModal"
      margin="10px"
      color="#31b9be"
      bgcolor="transparent"
      width="30px"
      padding="0"
      icon="close-blue"
    ></Button>
    <h3>{{ $t("general.milestone.select") }}</h3>

    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="form">
      <InputField
        :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }"
        :inputStyles="{ border: 0, margin: 0 }"
        class="input"
        v-model="title"
        :labelTitle="$t('general.milestone.presets.form-title')"
        :placeholder="$t('general.milestone.presets.form-title-placeholder')"
        style="margin: 16px"
        ref="title"
      />
      <InputField
        :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }"
        :inputStyles="{ border: 0, margin: 0 }"
        class="input"
        v-model="description"
        :labelTitle="$t('general.milestone.presets.form-desc')"
        :placeholder="$t('general.milestone.presets.form-desc-placeholder')"
        style="margin: 16px"
      />
      <IconPicker @select="icon => (this.icon = icon)" />
    </div>

    <LoadingButton v-if="loading" style="margin: 16px 0"></LoadingButton>
    <div v-else>
      <Button
        @click.native="addMilestone()"
        :title="$t('general.milestone.presets.action-save')"
        style="margin: 16px 0"
      />
    </div>
  </modal>
</template>

<script>
import { neoparentPosts } from "@/api";

export default {
  name: "CreateMilestoneModal",
  data() {
    return {
      title: "",
      description: "",
      icon: null,
      loading: false,
      error: ""
    };
  },
  mounted() {},
  methods: {
    closeModal() {
      this.title = "";
      this.description = "";
      this.icon = null;
      this.$modal.hide("create-milestone-modal");
      this.$modal.show("milestone-modal");
    },
    addMilestone() {
      this.loading = true;

      const data = {
        title: this.title,
        description: this.description,
        icon: this.icon,
        patientId: this.$store.getters.patient.id
      };
      this.consoleLog(data);

      // Create new
      this.consoleLog("Creating new milestone for patient");
      neoparentPosts
        .addMilestone(data)
        .then(result => {
          this.loading = false;
          this.consoleLog(result);
          this.closeModal();
        })
        .catch(err => {
          this.loading = false;
          this.error = err.response.data.message;
          this.consoleLog(err);
          this.closeModal();
        });
    }
  }
};
</script>

<style scoped>
ul {
  flex-direction: column;
  display: flex;
}

li {
  padding: 1rem 0rem;
}

ul :not(:last-child) {
  border-bottom: 1px solid #31b9be;
}

h3 {
  margin-right: 20px;
  margin-left: 20px;
}
</style>
